/* eslint-disable react-hooks/exhaustive-deps */
import clsx from 'clsx'
import {Link} from 'react-router-dom'
import {KTIcon, toAbsoluteUrl} from '../../../helpers'
import {useLayout} from '../../core'
import {Header} from './Header'
import {Navbar} from './Navbar'
import { useAppSelector } from 'src/redux/storeHooks'
import { useFreeTrialDeferredOnboarding } from 'src/hooks/useFreeTrialDeferredOnboarding'
import { TwakScript } from 'src/externalScript/TwakScript'
import ImpersonationSessionBadge from 'src/components/impersonation/ImpersonationSessionBadge'
import {
  isAdminProfileDuringImpersonation,
  isImpersonationSessionActive,
} from 'src/utils/impersonationTokens'

export function HeaderWrapper() {
  const {config, classes} = useLayout()
  const { fetchedUserAccountData } = useAppSelector(state=>state.userAccountData)
  const { isDeferredFreeTrialOnboarding, handleDeferredNavClick, openOnboardingWizard } =
    useFreeTrialDeferredOnboarding()
  const impersonationCustomerName =
    isImpersonationSessionActive() && isAdminProfileDuringImpersonation(fetchedUserAccountData)
      ? undefined
      : fetchedUserAccountData?.name
  if (!config.app?.header?.display) {
    return null
  }

  return (
    <>
    <div id='kt_app_header' className='app-header'>
      <div
        id='kt_app_header_container'
        className={clsx(
          'app-container flex-lg-grow-1 w-100 ',
          classes.headerContainer.join(' '),
          config.app?.header?.default?.containerClass
        )}
      >
        {config.app.sidebar?.display && (
          <>
            <div
              className='d-flex align-items-center d-lg-none ms-n2 me-2'
              title='Show sidebar menu'
            >
              <div
                className='btn btn-icon btn-active-color-primary w-35px h-35px'
                id='kt_app_sidebar_mobile_toggle'
              >
                <KTIcon iconName='abstract-14' className=' fs-1' />
              </div>
              <div className='d-flex  align-items-center flex-grow-1 flex-lg-grow-0'>
                <Link
                  to='/dashboard'
                  className='d-lg-none'
                  onClick={(event) => {
                    if (isDeferredFreeTrialOnboarding) {
                      handleDeferredNavClick(event)
                      return
                    }
                    openOnboardingWizard()
                  }}
                >
                  <img
                    alt='Logo'
                    src={toAbsoluteUrl('/media/logos/favicon.png')}
                    className='  ms-2'

                    style={{ width: '50px', height: '50px' }}  
                  />
                </Link>
              </div>
              <ImpersonationSessionBadge
                customerName={impersonationCustomerName}
                className='ms-3'
              />
            </div>
            
          </>
        )}

        {!(config.layoutType === 'dark-sidebar' || config.layoutType === 'light-sidebar') && (
          <div className='d-flex align-items-center flex-grow-1 flex-lg-grow-0 me-lg-15'>
            <Link
              to='/dashboard'
              onClick={(event) => {
                if (isDeferredFreeTrialOnboarding) {
                  handleDeferredNavClick(event)
                  return
                }
                openOnboardingWizard()
              }}
            >
              {config.layoutType !== 'dark-header' ? (
                <img
                  alt='Logo'
                  src={toAbsoluteUrl('/media/logos/favicon.png')}
                  className='h-20px h-lg-30px ms-4 app-sidebar-logo-default'
                />
              ) : (
                <>
                  <img
                    alt='Logo'
                    src={toAbsoluteUrl('/media/logos/favicon.png')}
                    className='h-20px h-lg-30px app-sidebar-logo-default theme-light-show'
                  />
                  <img
                    alt='Logo'
                    src={toAbsoluteUrl('/media/logos/favicon.png')}
                    className='h-20px h-lg-30px app-sidebar-logo-default theme-dark-show'
                  />
                </>
              )}
            </Link>
          </div>
        )}

        <div className='d-none d-lg-flex align-items-center flex-shrink-0'>
          <ImpersonationSessionBadge customerName={impersonationCustomerName} />
        </div>

        <div
          id='kt_app_header_wrapper'
          className='d-flex align-items-stretch justify-content-between flex-lg-grow-1'
        >
          {config.app.header.default?.content === 'menu' &&
            config.app.header.default.menu?.display && (
              <div
                className='app-header-menu app-header-mobile-drawer align-items-stretch'
                data-kt-drawer='true'
                data-kt-drawer-name='app-header-menu'
                data-kt-drawer-activate='{default: true, lg: false}'
                data-kt-drawer-overlay='true'
                data-kt-drawer-width='225px'
                data-kt-drawer-direction='end'
                data-kt-drawer-toggle='#kt_app_header_menu_toggle'
                data-kt-swapper='true'
                data-kt-swapper-mode="{default: 'append', lg: 'prepend'}"
                data-kt-swapper-parent="{default: '#kt_app_body', lg: '#kt_app_header_wrapper'}"
              >
                <Header />
              </div>
            )}
          <Navbar />
        </div>
      </div> 
    </div>
    <TwakScript/>
    </>
  )
}
